import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';

function ClubBudgetBreakdown() {
  const [chartData, setChartData] = useState({
    series: [300, 500, 120, 50, 20],
    options: {
      chart: {
        width: '100%',
        type: 'pie',
      },
      labels: ['Equipment & Supplies', 'Advisor’s Stipend', 'Refreshment', 'Logistics', 'Miscellaneous'],

      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'left',
            },
          },
        },
      ],
      legend: {
        formatter: function(val, opts) {
          return '<span style="font-weight: 600;     font-size: 15px; ;color: #000;">' + val + '</span>';
        },
      },
    },
  });

  return (
    <div>
      <div id="chart">
        <ReactApexChart options={chartData.options} series={chartData.series} type="pie" width={500} />
      </div>
      <div id="html-dist"></div>
    </div>
  );
}

export default ClubBudgetBreakdown;
